package waldo.sankan.lineamunicipalkmp.web

import androidx.compose.runtime.*
import lineamunicipalkmp.composeapp.generated.resources.Res
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable
import waldo.sankan.lineamunicipalkmp.web.screens.*

@Composable
fun App() {
    // 1. El ViewModel de sesión se mantiene.
    val loginViewModel = remember { LoginAdminViewModel() }
    val loginUiState by loginViewModel.uiState.collectAsState()

    if (loginUiState.rolAdmin == null) {
        // 2. Si no hay login, mostramos la pantalla de login.
        LoginAdminScreen(viewModel = loginViewModel)
    } else {
        // 3. ¡HAY LOGIN! Preparamos el ViewModel del panel.
        val adminProfile = loginUiState.rolAdmin!!
        val adminPanelViewModel = remember(adminProfile) {
            AdminPanelViewModel(adminProfile = adminProfile, onSessionClosed = { loginViewModel.logout() })
        }
        // ¡LA CLAVE! Nos suscribimos también al estado de este ViewModel.
        val panelUiState by adminPanelViewModel.uiState.collectAsState()

        // 4. ¡EL NUEVO CENTRO DE MANDO UNIFICADO (CENTRO + ESTADIO)!
        when (adminProfile.rol) {
            "OPERADOR_DRON", "OPERADOR_CAMARAS" -> {
                Div({ style { fontFamily("sans-serif") } }) {
                    when {
                        // --- 1. CAPACIDAD DE REPORTE (NUEVA MISIÓN) ---
                        panelUiState.showIngresoIncidenciaView -> {
                            IngresoIncidenciaScreen(
                                viewModel = adminPanelViewModel,
                                onBack = { adminPanelViewModel.onIngresoIncidenciaBackClicked() }
                            )
                        }
                        // --- DETALLE DE INCIDENCIA (RADAR DE CAMPO CONEXIÓN TOTAL) ---
                        panelUiState.selectedIncidencia != null -> {
                            val selected = panelUiState.selectedIncidencia!!
                            IncidenciaDetailScreen(
                                incidencia = selected,
                                viewModel = adminPanelViewModel,
                                uiState = panelUiState,
                                rolAdmin = adminProfile,
                                onBackToPanel = { adminPanelViewModel.onIncidenciaSelected(null) },
                                onBackToInforme = { adminPanelViewModel.onIncidenciaSelected(null) },
                                onEstadoChange = { newState, file -> adminPanelViewModel.changeIncidenciaStatus(selected.id, newState, file) },
                                mensajeParaCiudadano = panelUiState.mensajeParaCiudadano,
                                onMensajeParaCiudadanoChanged = adminPanelViewModel::onMensajeParaCiudadanoChanged,
                                onEnviarMensajeCiudadano = { adminPanelViewModel.enviarMensajeAlCiudadano(selected.id) },
                                mensajeParaSolucionador = panelUiState.mensajeParaSolucionador,
                                onMensajeParaSolucionadorChanged = adminPanelViewModel::onMensajeParaSolucionadorChanged,
                                onEnviarMensajeSolucionador = { adminPanelViewModel.enviarMensajeAlSolucionador(selected.id) },
                                mensajeParaDron = panelUiState.mensajeParaDron,
                                onMensajeParaDronChanged = adminPanelViewModel::onMensajeParaDronChanged,
                                onEnviarMensajeAlDron = { adminPanelViewModel.enviarMensajeAlDron(selected.id) },
                                mensajeParaAdmin = panelUiState.mensajeParaAdmin,
                                onMensajeParaAdminChanged = adminPanelViewModel::onMensajeParaAdminChanged,
                                onEnviarMensajeAlAdmin = { adminPanelViewModel.enviarMensajeAlAdmin(selected.id) }
                            )
                        }
                        // --- 2. VISTA DE DETALLE (EL OJO DE CAMPO) ---
                        panelUiState.selectedIncidenciaDron != null -> {
                            key(panelUiState.selectedIncidenciaDron) {
                                DroneDetailScreen(
                                    incidencia = panelUiState.selectedIncidenciaDron!!,
                                    viewModel = adminPanelViewModel,
                                    uiState = panelUiState,
                                    onBack = { adminPanelViewModel.onDroneIncidenciaSelected(null) },
                                    mensajeParaAdmin = panelUiState.mensajeParaAdmin,
                                    onMensajeParaAdminChanged = adminPanelViewModel::onMensajeParaAdminChanged,
                                    onEnviarMensajeAlAdmin = { adminPanelViewModel.enviarMensajeAlAdmin(panelUiState.selectedIncidenciaDron!!.id) }
                                )
                            }
                        }

                            // --- NUEVO: CONEXIÓN AL RADAR GEOGRÁFICO ---
                        panelUiState.showMapView -> {
                                MapScreen(
                                    viewModel = adminPanelViewModel,
                                    onBack = { adminPanelViewModel.onMapBackClicked() }
                                )
                        }

                        // --- 3. VISTAS DE LISTA INDEPENDIENTES ---
                        adminProfile.rol == "OPERADOR_DRON" -> {
                            DroneVerificationScreen(
                                viewModel = adminPanelViewModel,
                                onBack = { loginViewModel.logout() }
                            )
                        }

                        adminProfile.rol == "OPERADOR_CAMARAS" -> {
                            CamerasVerificationScreen(
                                viewModel = adminPanelViewModel,
                                onBack = { loginViewModel.logout() }
                            )
                        }
                    }

                    // --- 🖼️ MODAL VISOR DEL PLANO CUADRANTE (UNIFICADO) ---
                    if (panelUiState.showPlanCuadranteModal) {
                        Div({
                            style {
                                position(Position.Fixed); top(0.px); left(0.px); width(100.vw); height(100.vh)
                                backgroundColor(Color("rgba(0,0,0,0.8)")); display(DisplayStyle.Flex)
                                justifyContent(JustifyContent.Center); alignItems(AlignItems.Center); property("z-index", "2000")
                            }
                            onClick { adminPanelViewModel.onHidePlanCuadranteModal() }
                        }) {
                            Div({
                                style {
                                    backgroundColor(Color.white); padding(12.px); borderRadius(12.px)
                                    maxWidth(90.percent); maxHeight(90.percent); position(Position.Relative)
                                }
                                onClick { it.stopPropagation() }
                            }) {
                                Button(attrs = {
                                    onClick { adminPanelViewModel.onHidePlanCuadranteModal() }
                                    style {
                                        position(Position.Absolute); top((-15).px); right((-15).px)
                                        width(35.px); height(35.px); borderRadius(50.percent)
                                        backgroundColor(Color.red); color(Color.white); fontWeight("bold")
                                        cursor("pointer"); border(2.px, LineStyle.Solid, Color.white)
                                    }
                                }) { Text("X") }

                                val currentComunaName = panelUiState.filtroComuna ?: adminProfile.comunaAsignadaDisplayName ?: "Arica"
                                val imageName = if (currentComunaName.contains("Arica", ignoreCase = true)) "sectoresarica.png"
                                                else "sectores${currentComunaName.lowercase().replace(" ", "")}.png"

                                Img(src = imageName, attrs = {
                                    style { maxWidth(100.percent); maxHeight(80.vh); borderRadius(8.px) }
                                })
                                H3({ style { textAlign("center"); margin(12.px, 0.px); color(Color.black) } }) { Text("Planimetr\u00EDa Territorial: $currentComunaName") }
                            }
                        }
                    }
                }
            }
            else -> {
                // Para roles Administrativos (General, Seguridad, Comunal)
                AdminPanelScreen(
                    viewModel = adminPanelViewModel,
                    onLogout = { loginViewModel.logout() },
                )
            }
        }
    }
}

fun main() {
    // La función main ahora es simple. Solo lanza la App.
    renderComposable(rootElementId = "root") {
        App()
    }
}
